import { EventEmitter } from 'eventemitter3';
import { SDKEvent, SDKEventType } from '../types';
import { ErrorPayload } from '../errors';

export class EventBus extends EventEmitter {
  emitBusEvent(type: SDKEventType | string, payload?: any): void {
    const event: SDKEvent = {
      type: type as SDKEventType,
      payload,
      timestamp: new Date().toISOString(),
    };
    this.emit(type, event);
  }

  emitError(message: string, details?: unknown): void {
    const errorPayload: ErrorPayload = { message, details };
    const event: SDKEvent = {
      type: 'error',
      payload: errorPayload,
      timestamp: new Date().toISOString(),
    };
    this.emit('error', event);
  }

  reset(): void {
    this.removeAllListeners();
  }
}

export const clientBus = new EventBus();
export const internalBus = new EventBus();
